import React from 'react'
import classNames from 'classnames'

import styles from './Onboarding.module.css'

const plans = [
  {
    name: 'starter',
    price: 20,
    bullets: [
      'Unlimited Actions',
      'Unlimited Runs',
      'API & Database Integrations',
    ],
  },
  {
    name: 'enterprise',
    price: 40,
    bullets: [
      'Everything in Starter',
      'Premium Support',
      '99.9% Uptime Guarantee',
    ],
  },
]

const Plan = function PlanItem({ plan, selected, onSelect }) {
  return (
    <div
      className={classNames(styles.plan, selected && styles.selected)}
      onClick={onSelect}
    >
      <div className={styles.planHeader}>
        <h5>{plan.name}</h5>
        <div className={styles.price}>
          <span className={styles.priceNumber}>{`$${plan.price}`}</span>
          <span> Per User</span>
        </div>
        <p>Billed Monthly</p>
      </div>
      <ul className={styles.description}>
        {plan.bullets.map(itm => (
          <li key={itm}>{itm}</li>
        ))}
      </ul>
    </div>
  )
}

export default function PlanSelector({ currentPlan, onChangePlan }) {
  return (
    <div className={styles.wrapper}>
      {plans.map(plan => (
        <Plan
          key={plan.name}
          plan={plan}
          selected={currentPlan === plan.name}
          onSelect={() => onChangePlan(plan.name)}
        />
      ))}
    </div>
  )
}
